/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DomesticV2MeTrackAbandonedSessionPost422Response
 */
export interface DomesticV2MeTrackAbandonedSessionPost422Response {
    /**
     * 
     * @type {string}
     * @memberof DomesticV2MeTrackAbandonedSessionPost422Response
     */
    'status'?: DomesticV2MeTrackAbandonedSessionPost422ResponseStatusEnum;
}

export const DomesticV2MeTrackAbandonedSessionPost422ResponseStatusEnum = {
    error: 'error'
} as const;

export type DomesticV2MeTrackAbandonedSessionPost422ResponseStatusEnum = typeof DomesticV2MeTrackAbandonedSessionPost422ResponseStatusEnum[keyof typeof DomesticV2MeTrackAbandonedSessionPost422ResponseStatusEnum];


